var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 426.36 98.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.82,0l-14.23,80.72s0,.02,0,.03h-59.73c-6.44,0-10.75-5.22-9.61-11.67l2.21-12.54h60.31l3.1-17.61h-60.31l3.78-21.46h60.31L317.73,0H14.51l-2.67,15.15L.27,80.72c-1.7,9.67,4.75,17.51,14.42,17.51h11.81l5.54-31.43h44.81c25.25,0,33.24-13.89,36.7-33.54,1.03-5.87,1.47-11.19,.92-15.78h13.04l-10.42,59.09c-2.11,11.96,5.88,21.66,17.84,21.66h205.89L358.14,0h-29.32ZM83.58,33.26c-1.73,9.82-6.2,13.89-18.41,13.89h-29.66l4.85-27.5h29.66c12.22,0,15.3,3.79,13.56,13.61Zm77.89,47.5h-5.74c-6.44,0-10.75-5.22-9.61-11.67l2.21-12.54h60.31l3.1-17.61h-60.31l3.78-21.46h71.4l-10.42,59.09c-.25,1.43-.36,2.83-.33,4.19h-54.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.43,42L426.36,0h-31.83l-36.67,39.67c-4.63,5.01-5.69,11.92-2.58,16.75l22.93,35.56c2.54,3.95,6.98,6.23,12.09,6.23h25.04l-29.56-45.49c-2.01-3.09-1.33-7.53,1.65-10.74Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7230ef92cc7959ec7458d0fc61dbfd4e.svg";
export { ForwardRef as ReactComponent };